import { render } from "./ListeFaqTag.vue?vue&type=template&id=ea0a22ee&ts=true"
import script from "./ListeFaqTag.vue?vue&type=script&lang=ts"
export * from "./ListeFaqTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__